export class SelectorCity {
  constructor(public name: string) {}
  public headCount?: number;
  public exp?: number;
  public latitude?: number;
  public longitude?: number;
  public authDisabled?: boolean;
  public centerCoordinate?: {
    x: number;
    y: number;
    z: number;
    coordinate: string;
    m: number;
    valid: true;
  };
  public boundary?: {
    x: number;
    y: number;
    z: number;
    coordinate: string;
    m: number;
    valid: true;
  }[];
}

export class SelectorCountry {
  constructor(
    public name: string,
    public code: string,
    public subTerritoriesCount: number,
    public disabled?: boolean
  ) {}
}

export class CitySearch {
  constructor(
    public cityId: string,
    public countryName: string,
    public countryCode: string,
    public continentName: string,
    public continentCode: string
  ) {}
}
